import {Injectable} from '@angular/core';

@Injectable()
export class Credit {

    public id: string;
    public creditDate: string;
    public creditTime: string;
    public creditAmount: string;
    public creditType: string;

    constructor(){}

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/credit.ts